import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { FormGroup, Label } from 'reactstrap';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import axios from 'axios';
import { API_URL } from '../../../helpers/app_url'; 

async function fetchBuyerDeals() {
  try {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;

    const url = `${API_URL}ClientEngagement/allbyagentntypestatusaddress`;

    const body = {
      agentId: parseInt(localStorage.getItem("userId")),
      statusIds: [1],
      cTypeId: 2,
      address: ""
    };

    const response = await axios.post(url, body, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });

    return response.data;

  } catch (error) {
    console.error("Error fetching buyer deals:", error);
    return [];
  }
}

const ClientEngagementListSellerEmail = ({ selectedData }) => {
  const dispatch = useDispatch();
  const { values, errors, touched, setFieldValue, handleBlur } = useFormikContext();

  const [clientEngagements, setClientEngagements] = useState([]);

  useEffect(() => {
    const loadDeals = async () => {
      const data = await fetchBuyerDeals();
      setClientEngagements(data);
    };
    loadDeals();
  }, []);

  //const getType = (type) => (type === 1 ? 'Rent' : type === 2 ? 'Purchase' : 'Unknown Type');
  const getType = (type) => (type === 1 ? 'Sell' : type === 2 ? 'Lease' : 'Unknown Type');

  const formatYYMM = (dateStr) => {
    if (!dateStr) return "0000";
    const date = new Date(dateStr);
    const yy = String(date.getFullYear()).slice(2);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    return `${yy}${mm}`;
  };

  return (
    <FormGroup className="mb-3">
      <Label htmlFor="engagementId">Select Client</Label>
     <select
            name="engagementId"
            className={`form-control ${errors.engagementId && touched.engagementId ? "is-invalid" : ""}`}
            onChange={(e) => {
                const selectedEngagement = clientEngagements.find(item =>
                    item.clientListingsListVM?.id === Number(e.target.value)
                  );
                
                setFieldValue("engagementId", e.target.value);
                setFieldValue("clientId", selectedEngagement ? selectedEngagement.clientId : "");
            }}
            onBlur={handleBlur}
            value={values.engagementId}
            disabled={selectedData}
            >
            <option value="">Select</option>
            {clientEngagements?.map(option => {
                if (option.clientEngagementStatus === 3 && option.id !== Number(values.engagementId)) {
                return null;
                }

                const label = `${option.contactName} - ${getType(option.sellerType)} - (${option.id} - ${formatYYMM(option.lastAgreementDate)}) - ${option.clientListingsListVM?.listingAddress}`;

                return (
                <option key={option.id} value={option.clientListingsListVM?.id}>
                    {label}
                </option>
                );
            })}
            </select>
      {errors.engagementId && touched.engagementId && (
        <div className="invalid-feedback">{errors.engagementId}</div>
      )}
    </FormGroup>
  );
};

ClientEngagementListSellerEmail.propTypes = {
  selectedData: PropTypes.number
};

export default ClientEngagementListSellerEmail;
